import React, { useState, useEffect, useCallback } from 'react'
import { useSnackbar } from 'notistack'
//import MessageModal from '../../components/General/MessageModal'
import Spiner from '../../components/General/Spiner'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import Select from 'react-select'

const AreasCreateEdit = (props) => {
  const [spiner, setSpiner] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [selectedTableros, setSelectedTableros] = useState([])
  const [selectedTablerosBadges, setSelectedTablerosBadges] = useState([]) // corregido de 'Bages' a 'Badges'
  const [inputValue, setInputValue] = useState('')
  //const [coincidencias, setCoincidencias] = useState([])
  //const [message, setMessage] = useState('')
  //const [successInfo, setSuccess] = useState(false)
  const [idReporte, setIdReporte] = useState('')
  const [nombreArea, setNombreArea] = useState('')
  const [descripcion, setDescripcion] = useState('')
  const [listTablero, setListTablero] = useState([])
  //const [listTableroxArea, setListTableroxArea] = useState([])
  const [saveType, setSaveType] = useState('I')
  const [idsAEliminar, setIdsAEliminar] = useState([])

  const getInfoAreaDetail = useCallback(async () => {
    setSpiner(true)
    const respTableros = await ConfiguracionLogic.tableroLogic(0, 1, 1500, '')
    if (respTableros.success) {
      const formattedTableros = respTableros.data
        .filter(tablero => tablero.Nombre && tablero.Nombre.trim() !== '')
        .map(tablero => ({
          value: tablero.id,
          label: tablero.Nombre
        }))

      setListTablero(formattedTableros)
    }
    let resp
    setSaveType('I')
    if (localStorage.getItem("saveTypeAreas") === 'E' && localStorage.getItem("areaIdDetail") !== 0) {
      setSaveType('E')
      resp = await ConfiguracionLogic.areasLogic(localStorage.getItem("areaIdDetail"), 1, 1, '')
      if (resp.success) {
        const datForm = resp.data
        setIdReporte(datForm["idReporte"])
        setNombreArea(datForm["nombreArea"])
        setDescripcion(datForm["descripcion"])
        const tableros = Array.isArray(datForm["listTablero"]) ? datForm["listTablero"] : []
        const formattedTableros = tableros
          .filter(tablero => tablero.nombreTablero && tablero.nombreTablero.trim() !== '')
          .map(tablero => ({
            value: tablero.idTablero,
            label: tablero.nombreTablero
          }))

        //setListTableroxArea(formattedTableros)

        // Establecer los tableros que vienen del API como seleccionados
        //setSelectedTableros(formattedTableros) // Establecer tableros por defecto
        setSelectedTablerosBadges(formattedTableros) // Mostrar badges por defecto
      }
    }
    setTimeout(() => {
      enqueueSnackbar(respTableros.message, {
        variant: respTableros.variant,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      })
      setSpiner(false)
    }, 1000)
  }, [enqueueSnackbar])

  useEffect(() => {
    getInfoAreaDetail()
  }, [getInfoAreaDetail])

  const handleTablerosChange = (selectedOptions) => {
    setSelectedTableros(selectedOptions || [])
  }

  const handleInputChange = (e) => {
    const value = e.target.value
    setInputValue(value)

    /*if (value) {
      const coincidenciasFiltradas = listTableroxArea.filter(tablero =>
        tablero.label.toLowerCase().includes(value.toLowerCase())
      ).map(tablero => tablero.label) // Mapea a solo los nombres

      //setCoincidencias(coincidenciasFiltradas)
    } else {
      //setCoincidencias([]) // Limpiar coincidencias si el input está vacío
    }*/
  }

  const handledSave = async (event) => {
    event.preventDefault()
    setSpiner(true)
    const resp = await ConfiguracionLogic.saveEditAreaLogic(localStorage.getItem("areaIdDetail"), event.target, saveType, selectedTableros, idsAEliminar)
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
    setSpiner(false)
    if (saveType === 'I') {
      if (resp.success) {
        localStorage.setItem("areaIdDetail", resp.data)
        localStorage.setItem("saveTypeAreas", 'E')
        setSelectedTableros([])
        localStorage.setItem('areaIdDetail', 0)
        localStorage.setItem('saveTypeAreas', 'I')
        window.location.href = global.AREAS
      }
    }
    if (idsAEliminar.length > 0) {
      if (!resp.success) {
        setIdsAEliminar([])
        getInfoAreaDetail()
      }
    }
    if (resp.success) {
      getInfoAreaDetail()
      setSelectedTableros([])
      setSelectedTableros([])
    }
    //window.location.reload();
     window.location.href = global.AREAS;
  }

  /*const handleSelectCoincidencia = (nombre) => {
    setSelectedTablerosBadges((prev) => [...prev, nombre])
    setInputValue('')
    setCoincidencias([])
  }*/

  const handleRemoveTablero = (indexToRemove, id) => {
    setSelectedTablerosBadges((prevTableros) =>
      prevTableros.filter((_, index) => index !== indexToRemove)
    )

    setIdsAEliminar((prevIds) => [...prevIds, { idTablero: id, esActivoTablero: 'N' }]);

    const updatedTableros = selectedTablerosBadges.filter((_, i) => i !== indexToRemove);
    setSelectedTablerosBadges(updatedTableros);
    setSaveType('E')
  }

  const handleRedirectBack = (item) => {
    localStorage.setItem('areaIdDetail', 0)
    localStorage.setItem('saveTypeAreas', 'I')
    window.location.href = global.AREAS
  }

  return (
    <div className="content-wrapper">
      <Spiner opt={spiner} />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <button className="btn btn-default" onClick={handleRedirectBack}>
                    <i className="fas fa-arrow-left"></i> Regresar al listado de áreas
                  </button>
                  <br /><br />
                  <form action="/" method="POST" onSubmit={(e) => { handledSave(e) }}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="card" style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '8px' }}>
                          <div className="form-group">
                            <label>Nombre *</label>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              className="form-control"
                              value={nombreArea}
                              onChange={e => setNombreArea(e.target.value)}
                              placeholder="Ingresar nombre"
                            />
                          </div>
                          <div className="form-group">
                            <label className="highlighted-label">Id *</label>
                            <input
                              type="text"
                              id="idCode"
                              name="idCode"
                              className="form-control"
                              value={idReporte}
                              onChange={e => setIdReporte(e.target.value)}
                              placeholder="Ingresar Id"
                            />
                          </div>
                          <div className="form-group">
                            <label>Descripción *</label>
                            <textarea
                              id="description"
                              name="description"
                              className="form-control"
                              value={descripcion}
                              onChange={e => setDescripcion(e.target.value)}
                              placeholder="Ingresar descripción"
                            />
                          </div>
                          {/*}  <div className="form-group">
                            <label>Agregar Tableros *</label>
                            <Select
                              options={listTablero}
                              isMulti
                              id="tablero"
                              name="tablero"
                              value={selectedTableros}
                              onChange={handleTablerosChange}
                              placeholder="Seleccionar tablero"
                            />
                          </div>*/}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card" style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '8px' }}>
                          <div className="form-group">
                            <label>Tableros</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Buscar"
                              value={inputValue}
                              onChange={handleInputChange}
                            />

                            {/* Panel de coincidencias oculto porque ahora estamos filtrando badges directamente 
                            {coincidencias.length > 0 && (
                              <ul className="list-group position-absolute" style={{ zIndex: 1000, width: '100%', marginTop: '4.5rem' }}>
                                {coincidencias.map((nombre, index) => (
                                  <li
                                    key={index}
                                    className="list-group-item"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleSelectCoincidencia(nombre)}
                                  >
                                    {nombre}
                                  </li>
                                ))}
                              </ul>
                            )}*/}
                          </div>

                          <div style={{ marginTop: '10px' }}>
                            {selectedTablerosBadges
                              .filter((tablero) => tablero.label.toLowerCase().includes(inputValue.toLowerCase()))
                              .map((tablero, index) => (
                                <span key={tablero.value} className="badge badge-primary" style={{ margin: '5px 5px 5px 0' }}> {/* Margen vertical añadido */}
                                  {tablero.label}
                                  <button
                                    className="btn btn-sm btn-danger ml-1"
                                    onClick={() => {}}
                                    style={{ border: 'none', background: 'none', color: 'white' }}
                                  >
                                    x
                                  </button>
                                </span>
                              ))}
                          </div>
                        </div>
                      </div>


                    </div>
                    <div className="row justify-content-end mt-3">
                      <button type='submit' className="btn btn-primary mr-2">Guardar</button>
                      <button className="btn btn-default" onClick={handleRedirectBack}>Cancelar</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default AreasCreateEdit
